// Entry point for the build script in your package.json
import Rails from '@rails/ujs';
import './channels';
import './lib/jquery';
import './controllers';
import 'bootstrap/dist/js/bootstrap.bundle.js';
import select2 from 'select2';
import toastr from 'toastr';
import '@fortawesome/fontawesome-free/js/all';

import './application/users/show.js';

import './application/users/profiles/legal/beneficiaries_step.js';
import './application/users/profiles/legal/documents_step.js';

import './application/users/profiles/natural/enough_capital_step.js';
import './application/users/profiles/natural/financial_training_step.js';
import './application/users/profiles/natural/funds_risk_step.js';
import './application/users/profiles/natural/income.js';
import './application/users/profiles/natural/investment_goals_step.js';
import './application/users/profiles/natural/investment_horizon_step.js';
import './application/users/profiles/natural/performed_operation_step.js';
import './application/users/profiles/natural/politically_exposed_person_step.js';
import './application/users/profiles/natural/portfolio.js';
import './application/users/profiles/natural/profession_step.js';
import './application/users/profiles/natural/professional_step.js';
import './application/users/profiles/natural/us_person_step.js';

import './application/distributors/show.js';
import './application/distributors/registrations/edit.js';
import './application/distributors/subscriptions/create_subscription_modal.js';
import './application/distributors/dashboards/show.js';
import './application/distributors/users/new.js';
import './application/distributors/beneficiaries/new.js';

import './application/distributor_pre_registrations/new.js';

import './application/users/registrations/new.js';

import './application/users/subscriptions/details_step.js';
import './application/users/subscriptions/payment_info_step.js';

import './application/search_bar_filters.js';
require('@nathanvda/cocoon');

Rails.start();
select2();
toastr.options.toastClass = 'toastr';

function numberWithSpaces(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

function updateConfirmationText() {
  let $subscriptionAmountInput = $('form input#subscription_amount');
  const subscriptionAmount = $subscriptionAmountInput.val();

  if (subscriptionAmount) {
    let shareNominalValue = parseInt($subscriptionAmountInput.data('share-value'));
    let shareCount = 1;

    if (isNaN(shareNominalValue)) {
      shareNominalValue = 1;
    }

    if (subscriptionAmount > 0 && shareNominalValue > 0) {
      shareCount = Math.max(Math.floor(subscriptionAmount / shareNominalValue), 1);
    }

    $('span#confirmation-text-model-amount').html(numberWithSpaces(subscriptionAmount));
    $('#confirmation-text-model').change();
    $('span#confirmation-text-model-share-value').html(shareCount);
    if (shareCount > 1) {
      $('span#confirmation-text-model-share-plurial').text('s');
    } else {
      $('span#confirmation-text-model-share-plurial').text('');
    }
  }
}

$(function () {
  if ($('.flash.info')[0]) {
    toastr.info($('.flash.info').text());
  }
  if ($('.flash.success')[0]) {
    toastr.success($('.flash.success').text());
  }
  if ($('.flash.error')[0]) {
    toastr.error($('.flash.error').text());
  }
  if ($('.flash.alert')[0]) {
    toastr.error($('.flash.alert').text());
  }

  $('select').select2({ forcebelow: true });
  $("select[multiple='']").on('change', function () {
    if ($(this).val().includes('')) {
      $(this).val([]).trigger('change');
    }
  });

  updateConfirmationText();
  $('form input#subscription_amount').on('input', updateConfirmationText);

  $('body').on('change', '.custom-file-input', function () {
    if ($(this)[0].files[0] !== undefined) {
      $(this).parent().find('.custom-file-input-label').text($(this)[0].files[0].name);

      $(this).parent().find('.custom-file-input-label').addClass('fw-bold');

      $(this).parent().find('.icon-upload').addClass('d-none');

      $(this).parent().find('.upload-wording').addClass('d-none');

      $(this).parent().find('.icon-edit').removeClass('d-none');

      $(this).parent().find('.edit-wording').removeClass('d-none');

      $(this).parent().find('.input-file-completed').addClass('border-bottom border-4 border-secondary');
    }
  });

  $('.custom-file-input').hover(function () {
    $(this).parent().find('.custom-file-label').toggleClass('custom-file-label-shadow');

    $(this).parent().find('.file-input-button').toggleClass('text-secondary');

    $(this).parent().find('.icon-edit').toggleClass('icon-edit-hover');

    $(this).parent().find('.icon-document').toggleClass('animation-arrow');

    $(this).toggleClass('cursor-pointer');
  });

  $('.nav-tab-link').on('click', function () {
    $('#tabsMobile').collapse('hide');
  });
});
